var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "box-header" }, [
      _c("h3", { staticClass: "box-title" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.resource("DmVisualizer_ChangeInfo_BoxTitle")) +
            "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-body" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("info-logo", {
              attrs: { isEnabled: _vm.logoEnabled },
              on: {
                input: function($event) {
                  _vm.model.LogoPath = $event
                },
                "set-enabled": function($event) {
                  _vm.logoEnabled = $event
                }
              }
            }),
            _vm._v(" "),
            _c("info-opening-hours", {
              attrs: { isEnabled: _vm.openingHoursEnabled },
              on: {
                "set-enabled": function($event) {
                  _vm.openingHoursEnabled = $event
                },
                "update:monday": function($event) {
                  _vm.model.OpeningHours.monday = $event
                },
                "update:tuesday": function($event) {
                  _vm.model.OpeningHours.tuesday = $event
                },
                "update:wednesday": function($event) {
                  _vm.model.OpeningHours.wednesday = $event
                },
                "update:thursday": function($event) {
                  _vm.model.OpeningHours.thursday = $event
                },
                "update:friday": function($event) {
                  _vm.model.OpeningHours.friday = $event
                },
                "update:saturday": function($event) {
                  _vm.model.OpeningHours.saturday = $event
                },
                "update:sunday": function($event) {
                  _vm.model.OpeningHours.sunday = $event
                }
              }
            }),
            _vm._v(" "),
            _c("info-address", {
              attrs: { isEnabled: _vm.addressEnabled },
              on: {
                "set-enabled": function($event) {
                  _vm.addressEnabled = $event
                },
                "update:street": function($event) {
                  _vm.model.AddressInfo.street = $event
                },
                "update:zipcode": function($event) {
                  _vm.model.AddressInfo.zipcode = $event
                },
                "update:houseNo": function($event) {
                  _vm.model.AddressInfo.houseNo = $event
                },
                "update:city": function($event) {
                  _vm.model.AddressInfo.city = $event
                },
                "update:country": function($event) {
                  _vm.model.AddressInfo.country = $event
                }
              }
            }),
            _vm._v(" "),
            _c("info-website", {
              attrs: { isEnabled: _vm.websiteEnabled },
              on: {
                input: function($event) {
                  _vm.model.Website = $event
                },
                "set-enabled": function($event) {
                  _vm.websiteEnabled = $event
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("info-email", {
              attrs: { isEnabled: _vm.emailEnabled },
              on: {
                input: function($event) {
                  _vm.model.Email = $event
                },
                "set-enabled": function($event) {
                  _vm.emailEnabled = $event
                }
              }
            }),
            _vm._v(" "),
            _c("info-remarks", {
              attrs: { isEnabled: _vm.remarksEnabled },
              on: {
                input: function($event) {
                  _vm.model.Remarks = $event
                },
                "set-enabled": function($event) {
                  _vm.remarksEnabled = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-light mr-3",
              on: {
                click: function($event) {
                  return _vm.$emit("cancel-change-info")
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.resource("DmVisualizer_ChangeInfo_CancelButton"))
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: { click: _vm.confirmRequest }
            },
            [_vm._v(_vm._s(_vm.resource("DmVisualizer_ChangeInfo_SendButton")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }